// extracted by mini-css-extract-plugin
module.exports = {"container":"_3jJrCDRfI3TkWfGmDSEaij","deleteIcon":"_3aJuO2XNqi1PmVT79m6wUI"};